import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { Link } from "react-router-dom";
import { FAQS } from "../data/staticData";
import Reveal from "../components/Reveal";

export default function FAQ() {
  return (
    <div data-testid="page-faq">
      <section className="container-fld py-20">
        <div className="overline mb-4">// Knowledge Base</div>
        <h1 className="font-tactical text-5xl md:text-7xl font-bold uppercase text-white tracking-tight leading-none">
          Frequently <span className="text-[#7CFF00]">Asked.</span>
        </h1>
        <p className="mt-6 max-w-2xl text-zinc-400 text-lg leading-relaxed">
          Quick answers to the questions we hear most. Don't see yours? Open the
          chat in the corner — or call us directly.
        </p>
      </section>

      <section className="container-fld pb-20 max-w-3xl">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="tactical-card border-x border-y border-white/10 rounded-none px-5"
              >
                <AccordionTrigger className="font-tactical text-left uppercase tracking-wider text-white hover:text-[#7CFF00] hover:no-underline py-5 text-base">
                  <span className="flex items-start gap-4">
                    <span className="font-mono-tactical text-[#7CFF00] text-sm">
                      0{i + 1}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-zinc-400 leading-relaxed pb-5 pl-9">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <div className="mt-16 tactical-card p-8 text-center">
          <div className="overline mb-3">// Still got questions?</div>
          <h3 className="font-tactical text-2xl md:text-3xl uppercase text-white tracking-tight">
            We're real veterans on the other end.
          </h3>
          <div className="mt-6 flex gap-3 justify-center flex-wrap">
            <Link to="/contact" className="btn-primary">Contact Us</Link>
            <Link to="/booking" className="btn-secondary">Book a Class</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
